import CountUp from 'react-countup';
import { Icon } from '@iconify/react';

import useGetDynamicForm from '../../../hooks/Forms/useGetDynamicForm.js';
// import { FormCard } from './FormCard.jsx';
import Loading from '../../../components/Shared/Loader/Loading';
import { Card, CardBody, CardExpandToggler } from '../../../components/card/card.jsx';
import { useTranslation } from 'react-i18next';
import Pie from '../../dashboard/Pie.jsx';
import Bar from '../../dashboard/Bar.jsx';
import Line from '../../dashboard/Line.jsx';
import Breadcrumb from '../../../components/Shared/Breadcrumb';

// const AmeDahboard = () => {
//   const { i18n } = useTranslation();
//   const { loading, DynamicFormAme, error } = useGetDynamicForm();

//   const pieChartData = {
//     title: 'توزيع حالة الطلبات',
//     labels: ['قيد الانتظار', 'مقبولة', 'مرفوضة'],
//     series: [40, 30, 20],
//   };

//   const barChartData = {
//     title: 'الطلبات الشهرية',
//     categories: ['يناير', 'فبراير', 'مارس', 'أبريل'],
//     series: [
//       {
//         name: 'الطلبات',
//         data: [10, 20, 15, 25],
//       },
//     ],
//   };

//   const lineChartData = {
//     title: 'الطلبات المعالجة أسبوعياً',
//     categories: ['الأسبوع 1', 'الأسبوع 2', 'الأسبوع 3', 'الأسبوع 4'],
//     series: [
//       {
//         name: 'الطلبات المعالجة',
//         data: [5, 15, 20, 25],
//       },
//     ],
//   };

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: null,
//           },
//         ]}
//       />
//       <Loading loading={loading} error={error}>
//         <CardBody>
//           <div className="row">
//             <div className="col-12 col-sm-6 col-lg-3 mb-3">
//               <Card className="h-100">
//                 <CardBody>
//                   <div className="d-flex fw-bold mb-3">
//                     <span className="flex-grow-1">
//                       {i18n.language === 'en' ? 'Total Requests' : 'إجمالي الطلبات'}
//                     </span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 text-purple">
//                         <CountUp end={150} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <Icon
//                         icon="mdi:clipboard-list-outline"
//                         className="text-purple"
//                         style={{ fontSize: '4rem' }}
//                       />
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-12 col-sm-6 col-lg-3 mb-3">
//               <Card className="h-100">
//                 <CardBody>
//                   <div className="d-flex fw-bold mb-3">
//                     <span className="flex-grow-1">
//                       {i18n.language === 'en' ? 'Approved Requests' : 'الطلبات الموافق عليها'}
//                     </span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 text-success">
//                         <CountUp end={90} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <Icon
//                         icon="ph:check-circle"
//                         className="text-success"
//                         style={{ fontSize: '4rem' }}
//                       />
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-12 col-sm-6 col-lg-3 mb-3">
//               <Card className="h-100">
//                 <CardBody>
//                   <div className="d-flex fw-bold mb-3">
//                     <span className="flex-grow-1">
//                       {i18n.language === 'en' ? 'Pending Requests' : 'الطلبات قيد الانتظار'}
//                     </span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 text-warning">
//                         <CountUp end={40} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <Icon
//                         icon="fa:hourglass-half"
//                         className="text-warning"
//                         style={{ fontSize: '4rem' }}
//                       />
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-12 col-sm-6 col-lg-3 mb-3">
//               <Card className="h-100">
//                 <CardBody>
//                   <div className="d-flex fw-bold mb-3">
//                     <span className="flex-grow-1">
//                       {i18n.language === 'en' ? 'Rejected Requests' : 'الطلبات المرفوضة'}
//                     </span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 text-danger">
//                         <CountUp end={20} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <Icon
//                         icon="mdi:close-circle-outline"
//                         className="text-danger"
//                         style={{ fontSize: '4rem' }}
//                       />
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//           <div className="row">
//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">{pieChartData.title} </span>
//                     <CardExpandToggler />
//                   </div>
//                   <Pie labels={pieChartData.labels} series={pieChartData.series} height={400} />
//                 </CardBody>
//               </Card>
//             </div>
//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold"> {barChartData.title}</span>
//                     <CardExpandToggler />
//                   </div>
//                   <Bar
//                     categories={barChartData.categories}
//                     series={barChartData.series}
//                     height={400}
//                   />
//                 </CardBody>
//               </Card>
//             </div>
//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold"> {lineChartData.title}</span>
//                     <CardExpandToggler />
//                   </div>
//                   <Line categories={lineChartData.categories} series={lineChartData.series} />
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         </CardBody>
//       </Loading>
//     </>
//   );
// };

// export default AmeDahboard;


const AmeDahboard = () => {
  const { i18n } = useTranslation();
  const { loading, DynamicFormAme, error } = useGetDynamicForm();

  const pieChartData = {
    title: i18n.language === 'en' ? 'Request Status Distribution' : 'توزيع حالة الطلبات',
    labels: i18n.language === 'en' ? ['Pending', 'Approved', 'Rejected'] : ['قيد الانتظار', 'مقبولة', 'مرفوضة'],
    series: [40, 30, 20],
  };

  const barChartData = {
    title: i18n.language === 'en' ? 'Monthly Requests' : 'الطلبات الشهرية',
    categories: i18n.language === 'en' ? ['January', 'February', 'March', 'April'] : ['يناير', 'فبراير', 'مارس', 'أبريل'],
    series: [
      {
        name: i18n.language === 'en' ? 'Requests' : 'الطلبات',
        data: [10, 20, 15, 25],
      },
    ],
  };

  const lineChartData = {
    title: i18n.language === 'en' ? 'Weekly Processed Requests' : 'الطلبات المعالجة أسبوعياً',
    categories: i18n.language === 'en' ? ['Week 1', 'Week 2', 'Week 3', 'Week 4'] : ['الأسبوع 1', 'الأسبوع 2', 'الأسبوع 3', 'الأسبوع 4'],
    series: [
      {
        name: i18n.language === 'en' ? 'Processed Requests' : 'الطلبات المعالجة',
        data: [5, 15, 20, 25],
      },
    ],
  };

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: i18n.language === 'en' ? 'Home' : 'الرئيسية',
            link: null,
          },
        ]}
      />
      <Loading loading={loading} error={error}>
        <CardBody>
          <div className="row">
            <div className="col-12 col-sm-6 col-lg-3 mb-3">
              <Card className="h-100">
                <CardBody>
                  <div className="d-flex fw-bold mb-3">
                    <span className="flex-grow-1">
                      {i18n.language === 'en' ? 'Total Requests' : 'إجمالي الطلبات'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 text-purple">
                        <CountUp end={150} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <Icon
                        icon="mdi:clipboard-list-outline"
                        className="text-purple"
                        style={{ fontSize: '4rem' }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 mb-3">
              <Card className="h-100">
                <CardBody>
                  <div className="d-flex fw-bold mb-3">
                    <span className="flex-grow-1">
                      {i18n.language === 'en' ? 'Approved Requests' : 'الطلبات الموافق عليها'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 text-success">
                        <CountUp end={90} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <Icon
                        icon="ph:check-circle"
                        className="text-success"
                        style={{ fontSize: '4rem' }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 mb-3">
              <Card className="h-100">
                <CardBody>
                  <div className="d-flex fw-bold mb-3">
                    <span className="flex-grow-1">
                      {i18n.language === 'en' ? 'Pending Requests' : 'الطلبات قيد الانتظار'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 text-warning">
                        <CountUp end={40} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <Icon
                        icon="fa:hourglass-half"
                        className="text-warning"
                        style={{ fontSize: '4rem' }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-sm-6 col-lg-3 mb-3">
              <Card className="h-100">
                <CardBody>
                  <div className="d-flex fw-bold mb-3">
                    <span className="flex-grow-1">
                      {i18n.language === 'en' ? 'Rejected Requests' : 'الطلبات المرفوضة'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 text-danger">
                        <CountUp end={20} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <Icon
                        icon="mdi:close-circle-outline"
                        className="text-danger"
                        style={{ fontSize: '4rem' }}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">{pieChartData.title} </span>
                    <CardExpandToggler />
                  </div>
                  <Pie labels={pieChartData.labels} series={pieChartData.series} height={400} />
                </CardBody>
              </Card>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold"> {barChartData.title}</span>
                    <CardExpandToggler />
                  </div>
                  <Bar
                    categories={barChartData.categories}
                    series={barChartData.series}
                    height={400}
                  />
                </CardBody>
              </Card>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold"> {lineChartData.title}</span>
                    <CardExpandToggler />
                  </div>
                  <Line categories={lineChartData.categories} series={lineChartData.series} />
                </CardBody>
              </Card>
            </div>
          </div>
        </CardBody>
      </Loading>
    </>
  );
};

export default AmeDahboard;